<div *transloco="let t; prefix: 'checkout.shippingMethod.pickupFromStore'" class="map-dialog-container">
    @if (apiLoaded | async) {
    <google-map 
        height="100%" 
        width="100%" 
        (mapInitialized)="onMapInitialized($event)"
        (mapClick)="onMapClick()">
        
        @for (point of points; track point.label) {
            <map-marker
                [position]="{ lat: point.lat, lng: point.lng }"
                [options]=point.options
                (mapMouseover)="openInfoWindow(marker, point)"
                #marker="mapMarker">
            </map-marker>
        }

        <map-info-window>
            <div class="map-info-content p-3">
                <div class="text-base font-medium text-gray-900 mb-1 pr-6 mr-2 mb-4 leading-tight">
                    @if(selectedPoint?.isUserLocation){
                        {{ t('customerLocation') }}
                    } @else {
                        {{ selectedPoint?.company }}
                    }
                </div>
                
                <div class="text-sm text-gray-600 mb-3 leading-tight">
                    {{ selectedPoint?.street }} {{ selectedPoint?.houseNumber }}<br>
                    {{ selectedPoint?.postalCode }} {{ selectedPoint?.city }} {{ selectedPoint?.country }}
                </div>
                
                @if(!selectedPoint?.isUserLocation){
                    @if(selectedPoint?.isSelectedShop){
                        <p-button 
                            styleClass="button-base"
                            [disabled]="true"
                            (click)="selectPoint(selectedPoint)"
                            >{{ t('shopAlreadySelected') }}</p-button>
                    } @else {
                        <p-button 
                            styleClass="button-base"
                            (click)="selectPoint(selectedPoint)"
                            >{{ t('selectShop') }}</p-button>
                    }
                }
            </div>
        </map-info-window>
    </google-map>
    } @else {
        <div class="flex items-center justify-center h-full">
            <p>{{ t('mapLoading') }}</p>
        </div>
    }
</div>